import { DatePipe, formatDate, CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { SharedService } from '../services/shared.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-contract-briefly-report',
  templateUrl: './contract-briefly-report.component.html',
  styleUrl: './contract-briefly-report.component.scss'
})
export class ContractBrieflyReportComponent {

  contractData = [];
  advtFormBeans: any = []
  advtVBTotal: number = 0;
  advtFormBean: any
  advtBrieflyFormBeans: any = []
  advtBrieflyTotal: number = 0;
  advtMonthwiseFormBeans: any = []
  GSTfullreportFormBeans: any = []
  advtMonthwiseTotal: number = 0;
  advtOfficierbrieflyTotal: number = 0;
  advtCreditRegiInDetailsFormBeans: any = []
  advtCreditRegiInBrieflyFormBeans: any = []
  OutstandingInDetailFormBeans: any = []
  CreditadvtOffMTotal: number = 0;
  CreditadvtOffVBMTotal: number = 0;
  OutStandingIDTotal: number = 0;
  OutStandingIDNetAmtTotal: number = 0;
  OutStandingIDUnPaidTotal: number = 0;
  PaymentadvtOffInDFormBenas: any = []
  CreditadvtOffInDFormBenas: any = []
  PaymentadvtOffInDTotal: number = 0;
  PaymentadvtOffInDTotal2: number = 0;
  PaymentadvtOffInDTotal3: number = 0;

  CreditadvtOffInDTotal: number = 0;
  CredittadvtInDTotal: number = 0;
  CredittadvtInBrieflyTotal: number = 0;
  CreditNoteVBFormBeans: any = []
  CreditNoteVFormBeans: any = []
  CreditNoteMFormBeans: any = []
  CreditNoteNBFormBeans: any = []
  OutstandingB: any = []
  totalAdvtAmount: number = 0;
  totalNetAmount: number = 0;
  totalUnpaidAmount: number = 0;
  totalCR: number = 0;
  totalPaymentRegiInDetails: number = 0;
  CreditadvtOffBrieflyTotal: number = 0;
  // gst
  GSTAdvtAmt: number = 0;
  GSTDiscount: number = 0;
  GSTNetAdvtAmt: number = 0;
  CGSTAmount: number = 0;
  SGSTAmount: number = 0;
  AllGSTAmount: number = 0;
  filteredcontractData = [];
  startDate: any = '';
  endDate: any = '';
  repName = '';
  offRepName = '';
  advtName = '';
  reportType = '';
  totalData = {
    contract_prev_bal: 0,
    remaining_contract: 0,
    contract_amt: 0,
    contract_discnt_amt: 0,
    contract_net_amt: 0,
    contract_net_gst_amt: 0,
    contract_net_total: 0,
    total_march_end: 0,
    next_year: 0,
    till_date_used: 0,
    use_till_march_end: 0,
  };


  year: number;
  aprilFirstSunday;
  day = 0;
  diffDays = 0;
  totalweeks = 0;
  indetailsData = [];
  contractDetailsForm: FormGroup;
  selectedDateRange: string;
  currentDate = new Date();
  // currentDate= this.datePipe.transform(new Date(), 'dd-MM-yyyy ') || '';

  oneMonthAgo: any;
  onlyOutstandingInDetailFormBeans: any;
  onlyOutstandingB: any;
  onlyOutstandingVB: any;
  onlyOutStandingIDTotal: number;
  onlyOutStandingIDNetAmtTotal: number;
  onlyOutStandingIDUnPaidTotal: number;
  onlytotalUnpaidAmount: number;
  onlytotalNetAmount: number;
  onlytotalAdvtAmount: number;
  getpaiddata: any;
  getpaiddataP: any;
  getpersonalleddata: any;
  balancecfamt: any;
  Totalop: number;
  TotalDebit: number;
  TotalCredit: number;
  Totalbal: number;
  getpersonalledBridflydata: any;
  paidcommTotal: number;
  comtotal: number;
  getpendingreceipt: any;
  PendingReceiptAmt: number;
  PendingBalanceAmt: number;
  start: any;
  officer: any;
  taluka: any;
  district: any;
  end: any;
  rep: any;
  SubByZilha: any;
  districtName: any;
  talukaName: any;
  date: any;
  creditoutstandingindetails: any;
  creditonlyOutStandingIDTotal: number;
  creditonlyOutStandingIDNetAmtTotal: number;
  creditonlyOutStandingIDUnPaidTotal: number;
  creditlastonlytotalAdvtAmount: number;
  creditlastonlytotalNetAmount: number;
  creditlastonlytotalUnpaidAmount: number;
  creditoutstandongbrief: any;
  totalsubhilhapost: number;
  totalsubhilhahaste: number;
  totalsubhilhamagzine: number;
  totalsubhilhadigital: number;
  totalsubhilhatotal: number;
  SubByTaluka: any;
  SubByRep: any;
  SubByOffRep: any;
  totaloffrepsubhilhapost: number;
  totaloffrepsubhilhahaste: number;
  totaloffrepsubhilhatotal: number;
  totalrepsubhilhapost: number;
  totalrepsubhilhahaste: number;
  totalrepsubhilhatotal: number;
  totalzilhahapost: number;
  totalzilhahahaste: number;
  totalzilhahamagzine: number;
  totalzilhahadigital: number;
  totalzilhahatotal: number;
  aprilpost: number;
  aprilhaste: number;
  aprilmagzine: number;
  aprildigital: number;
  apriltotal: number;
  maypost: number;
  mayhaste: number;
  maymagzine: number;
  maydigital: number;
  maytotal: number;
  junepost: number;
  junehaste: number;
  junmagzine: number;
  jundigital: number;
  junetotal: number;
  julypost: number;
  julyhaste: number;
  julymagzine: number;
  julydigital: number;
  julytotal: number;
  augpost: number;
  aughaste: number;
  augmagzine: number;
  augdigital: number;
  augtotal: number;
  seppost: number;
  sephaste: number;
  sepmagzine: number;
  sepdigital: number;
  septotal: number;
  octopost: number;
  octohaste: number;
  octmagzine: number;
  octdigital: number;
  octototal: number;
  novpost: number;
  novhaste: number;
  novmagzine: number;
  novdigital: number;
  novtotal: number;
  decpost: number;
  dechaste: number;
  decmagzine: number;
  decdigital: number;
  dectotal: number;
  janpost: number;
  janhaste: number;
  janmagzine: number;
  jandigital: number;
  jantotal: number;
  febpost: number;
  febhaste: number;
  febmagzine: number;
  febdigital: number;
  febtotal: number;
  marchpost: number;
  marchhaste: number;
  marchmagzine: number;
  marchdigital: number;
  marchtotal: number;
  columnSums: number[] = [];
  typewisedistrict: any;
  pvarshik: number;
  ptrevarshik: number;
  ppanchvarshik: number;
  phindutva: number;
  hlova: number;
  hpanchvarshik: number;
  ptotal: number;
  htrevarshik: number;
  hhindutva: number;
  htotal: number;
  plova: number;
  typewisetaluka: any;
  hvarshik: number;
  gtotal: number;
  typewiseofficer: any;
  typewiserep: any;
  SubRemDistrict: any;
  SubRemDistrictBriefly: any;
  tapal_Total_4: any;
  haste_Total_4: any;
  tapal_Total_5: any;
  haste_Total_5: any;
  tapal_Total_6: any;
  haste_Total_6: any;
  tapal_Total_7: any;
  haste_Total_7: any;
  tapal_Total_8: any;
  haste_Total_8: any;
  tapal_Total_9: any;
  haste_Total_9: any;
  tapal_Total_10: any;
  haste_Total_10: any;
  tapal_Total_11: any;
  haste_Total_11: any;
  tapal_Total_12: any;
  haste_Total_12: any;
  tapal_Total_1: any;
  haste_Total_1: any;
  tapal_Total_2: any;
  haste_Total_2: any;
  tapal_Total_3: any;
  haste_Total_3: any;
  tapal_New_4: any;
  tapal_Renew_4: any;
  tapal_New_5: any;
  tapal_Renew_5: any;
  tapal_New_6: any;
  tapal_Renew_6: any;
  tapal_New_7: any;
  tapal_Renew_7: any;
  tapal_New_8: any;
  tapal_Renew_8: any;
  tapal_New_9: any;
  tapal_Renew_9: any;
  tapal_New_10: any;
  tapal_Renew_10: any;
  tapal_New_11: any;
  tapal_Renew_11: any;
  tapal_New_12: any;
  tapal_Renew_12: any;
  tapal_New_1: any;
  tapal_Renew_1: any;
  tapal_New_2: any;
  tapal_Renew_2: any;
  tapal_New_3: any;
  tapal_Renew_3: any;
  haste_New_4: any;
  haste_Renew_4: any;
  haste_New_5: any;
  haste_Renew_5: any;
  haste_New_6: any;
  haste_Renew_6: any;
  haste_New_7: any;
  haste_Renew_7: any;
  haste_New_8: any;
  haste_Renew_8: any;
  haste_New_9: any;
  haste_Renew_9: any;
  haste_New_10: any;
  haste_Renew_10: any;
  haste_New_11: any;
  haste_Renew_11: any;
  haste_New_12: any;
  haste_Renew_12: any;
  haste_New_1: any;
  haste_Renew_1: any;
  haste_New_2: any;
  haste_Renew_2: any;
  haste_New_3: any;
  haste_Renew_3: any;

  magzine_New_4: any;
  magzine_Renew_4: any;
  magzine_Total_4: any;
  magzine_New_5: any;
  magzine_Renew_5: any;
  magzine_Total_5: any;
  magzine_New_6: any;
  magzine_Renew_6: any;
  magzine_Total_6: any;
  magzine_New_7: any;
  magzine_Renew_7: any;
  magzine_Total_7: any;
  magzine_New_8: any;
  magzine_Renew_8: any;
  magzine_Total_8: any;
  magzine_New_9: any;
  magzine_Renew_9: any;
  magzine_Total_9: any;
  magzine_New_10: any;
  magzine_Renew_10: any;
  magzine_Total_10: any;
  magzine_New_11: any;
  magzine_Renew_11: any;
  magzine_Total_11: any;
  magzine_New_12: any;
  magzine_Renew_12: any;
  magzine_Total_12: any;
  magzine_New_1: any;
  magzine_Renew_1: any;
  magzine_Total_1: any;
  magzine_New_2: any;
  magzine_Renew_2: any;
  magzine_Total_2: any;
  magzine_New_3: any;
  magzine_Renew_3: any;
  magzine_Total_3: any;
  digital_New_4: any;
  digital_Renew_4: any;
  digital_Total_4: any;
  digital_New_5: any;
  digital_Renew_5: any;
  digital_Total_5: any;
  digital_New_6: any;
  digital_Renew_6: any;
  digital_Total_6: any;
  digital_New_7: any;
  digital_Renew_7: any;
  digital_Total_7: any;
  digital_New_8: any;
  digital_Renew_8: any;
  digital_Total_8: any;
  digital_New_9: any;
  digital_Renew_9: any;
  digital_Total_9: any;
  digital_New_10: any;
  digital_Renew_10: any;
  digital_Total_10: any;
  digital_New_11: any;
  digital_Renew_11: any;
  digital_Total_11: any;
  digital_New_12: any;
  digital_Renew_12: any;
  digital_Total_12: any;
  digital_New_1: any;
  digital_Renew_1: any;
  digital_Total_1: any;
  digital_New_2: any;
  digital_Renew_2: any;
  digital_Total_2: any;
  digital_New_3: any;
  digital_Renew_3: any;
  digital_Total_3: any;

  tapal_New_total: any;
  tapal_Renew_total: any;
  tapal_Total_total: any;
  haste_New_total: any;
  haste_Renew_total: any;
  haste_Total_total: any;
  magzine_New_total: any;
  magzine_Renew_total: any;
  magzine_Total_total: any;
  digital_New_total: any;
  digital_Renew_total: any;
  digital_Total_total: any;
  //------------------------------
  SubRemOffVBriefly: any;
  SubRemRepVBriefly: any;
  SubRemRepBriefly: any;
  total_New_4: any;
  total_Renew_4: any;
  total_Total_4: any;
  total_New_5: any;
  total_Renew_5: any;
  total_Total_5: any;
  total_New_6: any;
  total_Renew_6: any;
  total_Total_6: any;
  total_New_7: any;
  total_Renew_7: any;
  total_Total_7: any;
  total_New_8: any;
  total_Renew_8: any;
  total_Total_8: any;
  total_New_9: any;
  total_Renew_9: any;
  total_Total_9: any;
  total_New_10: any;
  total_Renew_10: any;
  total_Total_10: any;
  total_New_11: any;
  total_Renew_11: any;
  total_Total_11: any;
  total_New_12: any;
  total_Renew_12: any;
  total_Total_12: any;
  total_New_1: any;
  total_Renew_1: any;
  total_Total_1: any;
  total_New_2: any;
  total_Renew_2: any;
  total_Total_2: any;
  total_New_3: any;
  total_Renew_3: any;
  total_Total_3: any;
  total_New_total: any;
  total_Renew_total: any;
  total_Total_total: any;
  grandremtotal = 0;
  Month_total = 0;
  SubRemTaluka: any;
  SubRemOffRep: any;
  SubRemRep: any;
  old_data: any;
  getpendingreceiptrep: any;
  lastcontract: number;
  remaincontract: number;
  newcontract: number;
  agencydiscontract: number;
  totalcontract: number;
  gstcontract: number;
  grandtotalcontract: number;
  getdeliverytype: any;
  // prantname: any;

  totalrepsubhilhadigital: any;
  totalrepsubhilhamagzine: any;
  post_total_ROR: any;
  haste_total_ROR: any;
  post_jama: any;
  PaymentadvtOffInDTotal_netamt: any;
  beforegstamt: any;
  country: any;
  state: any;
  prant_name: any;
  districtWiseList: any;
  aprilpost1: number;
  aprilhaste1: number;
  aprilmagzine1: number;
  aprildigital1: number;
  apriltotal1: number;
  totalTalukaCount: number;
  stateWiseList: any[];
  officeWiseList: any[];
  representativeWiseList: any[];
  totalzilhahapost1: number;
  totalzilhahahaste1: number;
  totalzilhahamagzine1: number;
  totalzilhahadigital1: number;
  totalzilhahatotal1: number;
  prantWiseList: any[];

  renew_4: number;
  total_4: number;
  new_4: number;
  renew_5: number;
  new_5: number;
  total_5: number;
  renew_6: number;
  new_6: number;
  total_6: number;
  renew_7: number;
  new_7: number;
  total_7: number;
  renew_8: number;
  new_8: number;
  total_8: number;
  renew_9: number;
  new_9: number;
  total_9: number;
  renew_10: number;
  new_10: number;
  total_10: number;
  renew_11: number;
  new_11: number;
  total_11: number;
  renew_12: number;
  new_12: number;
  total_12: number;
  renew_1: number;
  new_1: number;
  total_1: number;
  renew_2: number;
  new_2: number;
  total_2: number;
  renew_3: number;
  new_3: number;
  total_3: number;
  renew_Total: number;
  new_Total: number;
  total_Total: number;
  total_Total4: number;
  SubRemOffRepbrief: any;
  totaloffrepsubhilhapost1: number;
  totaloffrepsubhilhahaste1: number;
  totaloffrepsubhildigital1: number;
  totalsubhilhamagzine1: number;
  totaloffrepsubhilhatotal1: number;
  totaloffrepsubhildigital: number;
  IGSTAmount: number;
  totalOffRepPost1: number;
  totalOffRepHaste1: number;
  totalOffRepmagzine1: number;
  totalOffRepdDigital1: number;
  totalOffReptotal1: number;
  totalOffRepDigital1: number;
  totalrepsubhilhapost1: number;
  totalrepsubhilhahaste1: number;
  totalrepsubhilhamagzine1: number;
  totalrepsubhilhadigital1: number;
  totalrepsubhilhatotal1: number;
  SubByZilhaBriefly: any;
  SubByTalukaIndetails: any;
  SubDelModeTalukaBriefly: any;
  New_4: number;
  Renew_4: number;
  SubRemRenewTalBriefly: any;
  advt_name: any;
  name: any;
  totalZilhaPostIndetail: number;
  totalZilhaHasteIndetails: number;
  totalZilhaMagzineIndetails: number;
  totalZilhaTotalIndetailTotal: number;
  totalZilhaDigitalIndetails: number;
  SubByZilhaIndetails: any;
  totalTalukaPostIndetail: number;
  totalTalukaHasteIndetails: number;
  totalTalukaMagzineIndetails: number;
  totalTalukaDigitalIndetails: number;
  totalTalukaTotalIndetailTotal: number;
  CredittadvtInDTotalother: number;
  CredittadvtInDTotalAmt: number;
  CredittadvtInBrieflyTotaltds: number;
  CredittadvtInBrieflyTotalother: number;
  CreditadvtOffInDTotalTds: number;
  CreditadvtOffInDTotalOther: number;
  CreditadvtOffVBMTotalTDS: number;
  CreditadvtOffVBMTotalOther: number;
  CreditadvtOffBrieflyTotalTds: number;
  CreditadvtOffBrieflyTotalOther: number;
  TotalCreditTotal: number;
  TotalcreditTDSAmt: number;
  TotalCreditOtherTotal: number;
  Totalnet: number;
  Totalrcv: number;
  totalbalance: number;
  issueDates1: any;

  advtGroup: any;
  Totaldirect: number;
  // creditTDSAmt :num


  constructor(
    private dialogRef: MatDialogRef<ContractBrieflyReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe,
    private sharedService: SharedService
  ) {
    this.contractDetailsForm = this.fb.group({
      start: ['', Validators.required],
      end: ['', Validators.required],
      // other form controls
    });
  }
  months: any
  issueDates: any
  // ngOnInit(): void {

  //   this.filterData();
  // this.reportType = this.data['reportType'];

  // // ... all your existing variable assignments ...
  // this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
  // this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
  // this.repName = this.data['repName'];
  // this.offRepName = this.data['offRepName'];
  // this.advtName     = this.data['name']       || ''; 
  // this.districtName = this.data['districtName'];
  // this.talukaName = this.data['talukaName'];
  // this.date = this.data['endDate'];
  // this.prant_name = this.data['prantname'];
  // this.country = this.data['country'];
  // this.state = this.data['state'];
  // this.issueDates1 = this.data['issue_date'];
  // this.issueDates = this.data.issueDates;

  //   if (this.reportType == 'briefly') {
  //   this.getBrieflyContractDetails();

  // } else if (this.reportType == 'indetail') {

  // } else if (this.reportType == 'indetail') {
  //   this.getIndetailsContractDetails();
  // } else if (this.reportType == 'indetailcontract') {
  //   this.getIndetailsContractDetails();
  // } else {
  //   this.contractData = this.data['contractData'];
  //   this.filterData();
  // }
  //   // console.log('aprilFirstSunday', this.aprilFirstSunday);


  //   this.calculatetotalweeks();

  //   this.getCreditNoteVB()
  //   this.getCreditNoteV()
  //   this.getCreditNoteM()
  //   this.getCreditNoteNB()
  //   this.getCreditRegiInBriefly()
  //   this.getCreditRegiOffInDetails()
  // }

  ngOnInit(): void {
    debugger;
    // ✅ STEP 1: Assign all data FIRST
    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'] || '';
    this.offRepName = this.data['offRepName'] || '';
    this.advtName = this.data['name'] || '';   // ← must be set BEFORE API calls
    this.districtName = this.data['districtName'] || '';
    this.talukaName = this.data['talukaName'] || '';
    this.date = this.data['endDate'] || '';
    this.prant_name = this.data['prantname'] || '';
    this.country = this.data['country'] || '';
    this.state = this.data['state'] || '';
    this.issueDates1 = this.data['issue_date'] || '';
    this.issueDates = this.data['issueDates'] || '';

    // ✅ STEP 2: Now call APIs (advtName is ready)
    if (this.reportType == 'briefly') {
      this.getBrieflyContractDetails();
    } else if (this.reportType == 'indetail' || this.reportType == 'indetailcontract') {
      this.getIndetailsContractDetails();
    } else {
      this.contractData = this.data['contractData'];
      this.filterData();
    }

    // ✅ STEP 3: Other non-dependent calls
    this.calculatetotalweeks();
    this.getCreditNoteVB();
    this.getCreditNoteV();
    this.getCreditNoteM();
    this.getCreditNoteNB();
    this.getCreditRegiInBriefly();
    this.getCreditRegiOffInDetails();
  }

  getIndetailsContractDetails() {
    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "issue_name": ""
    }


    this.service.getAllIndetailsContractDetails(req).subscribe((a) => {
      // console.log(a);
      this.contractData = a;
      this.filteredcontractData = a
      console.log(this.contractData, "contract deatail");
      // this.filterData();
      this.calculateTotal();
      this.getData();
    });
  }






  getChangedDateContract() {
    // update the selectedDateRange variable when the date range changes
    const startDate = this.contractDetailsForm.get('start').value;
    const endDate = this.contractDetailsForm.get('end').value;

    if (startDate && endDate) {
      this.selectedDateRange = `${startDate} to ${endDate}`;
    }
  }




  getCreditNoteVB() {

  }

  getCreditNoteV() {




  }

  getCreditNoteM() {


  }


  getCreditNoteNB() {
    this.service.getCreditNoteNB().subscribe((data: any) => {
      console.log("ADVT Data=", data);
      this.CreditNoteNBFormBeans = (data as any);;

      // Reset totals
      this.totalCR = 0;

      // Calculate totals
      for (let data of this.CreditNoteNBFormBeans) {

        this.totalCR += parseInt(data.credit_amt) || 0;
      }
    });
  }



  getCreditRegiInBriefly() {

  }



  getCreditRegiOffInDetails() {
    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "issue_name": "",
      "issue_date": this.issueDates1,
    }
    this.service.getCreditRegiOffInDetails(req).subscribe((data: any) => {
      console.log("creditIndetailoff", data)
      this.CreditadvtOffInDFormBenas = data as any;
      // Reset totals
      // this.CreditadvtOffInDTotal = 0;

      // Calculate totals
      this.CreditadvtOffInDTotal = 0; // Reset total before summing
      this.CreditadvtOffInDTotalTds = 0;
      this.CreditadvtOffInDTotalOther = 0;

      for (let rep_data of this.CreditadvtOffInDFormBenas) {
        if (rep_data.total) {  // Ensure value exists
          this.CreditadvtOffInDTotalTds += parseFloat(rep_data.tds_amt) || 0;
          this.CreditadvtOffInDTotalOther += parseFloat(rep_data.other_credit_amt) || 0;
          this.CreditadvtOffInDTotal += parseFloat(rep_data.total) || 0;
        }
      }

    });
  }

  today = new Date();
nexttoday = new Date();


  calculatetotalweeks() {
    for (let index = 0; index < 12; index++) {
      if (index < 3) {
        this.totalweeks += this.sundays(
          formatDate(this.nexttoday, 'yyyy', 'en-IN', 'GMT+0530'),
          index
        );
      } else {
        this.totalweeks += this.sundays(
          formatDate(this.today, 'yyyy', 'en-IN', 'GMT+0530'),
          index
        );
      }
    }
    // console.log(this.totalweeks);
  }

  firstSunday(month, year) {
    let tempDate = new Date();
    tempDate.setHours(0, 0, 0, 0);
    // first SUNDAY of april
    tempDate.setMonth(month);
    tempDate.setFullYear(year);
    tempDate.setDate(1);

    let day = tempDate.getDay();
    let toNextSun = day !== 0 ? 7 - day : 0;
    tempDate.setDate(tempDate.getDate() + toNextSun);

    // return formatDate(tempDate, 'dd/MM/yy', 'en-IN', 'GMT+0530');
    return tempDate;
  }

  secondSunday(month, year) {
    // console.log(
    //   'this.firstSunday(month, year)',
    //   formatDate(
    //     this.firstSunday(month, year),
    //     'dd-MM-yyyy',
    //     'en-IN',
    //     'GMT+0530'
    //   )
    // );
    let tempDate = new Date(this.firstSunday(month, year));
    // console.log('tempdate', tempDate);

    tempDate.setHours(0, 0, 0, 0);
    // first SUNDAY of april
    // tempDate.setMonth(month);
    // tempDate.setFullYear(year);
    tempDate.setDate(tempDate.getDate() + 7);

    let day = tempDate.getDay();
    // console.log('day', day);

    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  thirdSunday(month, year) {
    // console.log(
    //   'this.secondSunday(month, year)',
    //   formatDate(
    //     this.secondSunday(month, year),
    //     'dd-MM-yyyy',
    //     'en-IN',
    //     'GMT+0530'
    //   )
    // );
    let tempDate = new Date(this.secondSunday(month, year));
    // console.log('tempdate', tempDate);
    tempDate.setHours(0, 0, 0, 0);
    // first SUNDAY of april
    // tempDate.setMonth(month);
    // tempDate.setFullYear(year);
    tempDate.setDate(tempDate.getDate() + 7);

    let day = tempDate.getDay();
    // console.log('thirdsunday', day);

    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  fourthSunday(month, year) {
    let tempDate = new Date(this.thirdSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    // first SUNDAY of april
    // tempDate.setMonth(month);
    // tempDate.setFullYear(year);
    // console.log('tempDate', tempDate);
    tempDate.setDate(tempDate.getDate() + 7);
    let day = tempDate.getDay();
    // console.log('thirdsunday', day);
    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  fifthSunday(month, year) {
    let tempDate = new Date(this.fourthSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    // first SUNDAY of april
    // tempDate.setMonth(month);
    // tempDate.setFullYear(year);
    // console.log('tempDate', tempDate);
    tempDate.setDate(tempDate.getDate() + 7);

    let day = tempDate.getDay();
    // console.log('thirdsunday', day);
    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  sundays(year, month) {
    let day = 1;
    let counter = 0;
    let date = new Date(year, month, day);
    while (date.getMonth() === month) {
      if (date.getDay() === 6) {
        counter++;
      }
      day++;
      date = new Date(year, month, day);
    }
    return counter;
  }

  filterData() {
    if (
      this.startDate === '' &&
      this.endDate === '' &&
      this.repName === '' &&
      this.offRepName === '' &&
      this.advtName === ''
    ) {
      this.filteredcontractData = this.contractData;
    } else if (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.repName == '' &&
      this.offRepName == '' &&
      this.advtName == ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          a['contract_date'] >= this.startDate &&
          a['contract_date'] <= this.endDate
        );
      });
    } else if (
      this.startDate == '' &&
      this.endDate == '' &&
      this.repName !== '' &&
      this.offRepName == '' &&
      this.advtName == ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return this.repName.includes(a['rep_name']);
      });
    } else if (
      this.startDate == '' &&
      this.endDate == '' &&
      this.repName == '' &&
      this.offRepName !== '' &&
      this.advtName == ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return this.offRepName.includes(a['off_rep_name']);
      });
    } else if (
      this.startDate == '' &&
      this.endDate == '' &&
      this.repName == '' &&
      this.offRepName == '' &&
      this.advtName !== ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return this.advtName.includes(a['advt_name']);
      });
    } else if (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.repName !== '' &&
      this.offRepName == '' &&
      this.advtName == ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          a['contract_date'] >= this.startDate &&
          a['contract_date'] <= this.endDate &&
          this.repName.includes(a['rep_name'])
        );
      });
    } else if (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.repName == '' &&
      this.offRepName !== '' &&
      this.advtName == ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          a['contract_date'] >= this.startDate &&
          a['contract_date'] <= this.endDate &&
          this.offRepName.includes(a['off_rep_name'])
        );
      });
    } else if (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.repName == '' &&
      this.offRepName == '' &&
      this.advtName !== ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          a['contract_date'] >= this.startDate &&
          a['contract_date'] <= this.endDate &&
          this.advtName === a['advt_name']

        );
      });
    } else if (
      this.startDate == '' &&
      this.endDate == '' &&
      this.repName !== '' &&
      this.offRepName !== '' &&
      this.advtName == ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          this.repName.includes(a['rep_name']) &&
          this.offRepName.includes(a['off_rep_name'])
        );
      });
    } else if (
      this.startDate == '' &&
      this.endDate == '' &&
      this.repName !== '' &&
      this.offRepName == '' &&
      this.advtName !== ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          this.repName.includes(a['rep_name']) &&
          this.advtName.includes(a['advt_name'])
        );
      });
    } else if (
      this.startDate == '' &&
      this.endDate == '' &&
      this.repName == '' &&
      this.offRepName !== '' &&
      this.advtName !== ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          this.offRepName.includes(a['off_rep_name']) &&
          this.advtName.includes(a['advt_name'])
        );
      });
    } else if (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.repName !== '' &&
      this.offRepName !== '' &&
      this.advtName == ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          a['contract_date'] >= this.startDate &&
          a['contract_date'] <= this.endDate &&
          this.repName.includes(a['rep_name']) &&
          this.offRepName.includes(a['off_rep_name'])
        );
      });
    } else if (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.repName !== '' &&
      this.offRepName == '' &&
      this.advtName !== ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          a['contract_date'] >= this.startDate &&
          a['contract_date'] <= this.endDate &&
          this.repName.includes(a['rep_name']) &&
          this.advtName.includes(a['advt_name'])
        );
      });
    } else if (
      this.startDate == '' &&
      this.endDate == '' &&
      this.repName !== '' &&
      this.offRepName !== '' &&
      this.advtName !== ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (
          this.repName.includes(a['rep_name']) &&
          this.offRepName.includes(a['off_rep_name']) &&
          this.advtName.includes(a['advt_name'])
        );
      });
    } else if (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.repName !== '' &&
      this.offRepName !== '' &&
      this.advtName !== ''
    ) {
      this.filteredcontractData = this.contractData.filter((a) => {
        return (

          a['contract_date'] >= this.datePipe.transform(this.startDate, 'yyyy-MM-dd') &&
          a['contract_date'] <= this.datePipe.transform(this.endDate, 'yyyy-MM-dd') &&
          this.repName.includes(a['rep_name']) &&
          this.offRepName.includes(a['off_rep_name']) &&
          this.advtName.includes(a['advt_name'])
        );
      });
    }
    this.calculateTotal();
    // console.log(this.filteredcontractData);
  }

  calculateTotal() {
    for (
      let index = 0;
      index < Object.keys(this.filteredcontractData).length;
      index++
    ) {
      this.totalData['contract_prev_bal'] += parseFloat(
        this.filteredcontractData[index]['contract_prev_bal']
      );
      this.totalData['contract_amt'] += parseFloat(
        this.filteredcontractData[index]['contract_amt']
      );
      this.totalData['contract_discnt_amt'] += parseFloat(
        this.filteredcontractData[index]['contract_discnt_amt']
      );
      this.totalData['contract_net_amt'] += parseFloat(
        this.filteredcontractData[index]['contract_net_amt']
      );
      this.totalData['contract_net_gst_amt'] += parseFloat(
        this.filteredcontractData[index]['contract_net_gst_amt']
      );
      this.totalData['contract_net_total'] += parseFloat(
        this.filteredcontractData[index]['contract_net_total']
      );
    }
  }





  //For Remaining Subscription Renewal District Report 
  exportExcel1(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('print-section2');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }











  getData() {
    let data = this.uniqueData(
      this.filteredcontractData,
      (a) => a.off_rep_name
    );
    // console.log(data);

    for (let index = 0; index < data.length; index++) {
      let commonData = this.filteredcontractData.filter((a) => {
        return a.off_rep_name == data[index]['off_rep_name'];
      });

      // console.log(commonData);
      let sortedDataCommon = [];
      let contract_prev_bal = 0;
      let remaining_contract = 0;
      let contract_amt = 0;
      let contract_discnt_amt = 0;
      let contract_net_amt = 0;
      let contract_net_gst_amt = 0;
      let contract_net_total = 0;
      for (let i = 0; i < commonData.length; i++) {
        contract_prev_bal += parseFloat(commonData[i]['contract_prev_bal']);
        remaining_contract += parseFloat(commonData[i]['contract_bal_amt']);
        contract_amt += parseFloat(commonData[i]['contract_amt']);
        contract_discnt_amt += parseFloat(commonData[i]['contract_discnt_amt']);
        contract_net_amt += parseFloat(commonData[i]['contract_net_amt']);
        contract_net_gst_amt += parseFloat(
          commonData[i]['contract_net_gst_amt']
        );
        contract_net_total += parseFloat(commonData[i]['contract_net_total']);

        // console.log();

        sortedDataCommon.push({
          DS_ADVTID: commonData[i]['DS_ADVTID'],
          advt_amt: commonData[i]['advt_amt'],
          advt_discnt: commonData[i]['advt_discnt'],
          advt_name: commonData[i]['advt_name'],
          amount: commonData[i]['amount'],
          booking_date: commonData[i]['booking_date'],
          booking_no: commonData[i]['booking_no'],
          cgst: commonData[i]['cgst'],
          contract_amt: commonData[i]['contract_amt'],
          contract_bal_amt: commonData[i]['contract_bal_amt'],
          contract_bkng_advt_amt: commonData[i]['contract_bkng_advt_amt'],
          contract_date: commonData[i]['contract_date'],
          contract_discnt_amt: commonData[i]['contract_discnt_amt'],
          contract_id: commonData[i]['contract_id'],
          contract_net_amt: commonData[i]['contract_net_amt'],
          contract_net_gst_amt: commonData[i]['contract_net_gst_amt'],
          contract_net_total: commonData[i]['contract_net_total'],
          contract_no: commonData[i]['contract_no'],
          contract_period_from: commonData[i]['contract_period_from'],
          contract_period_to: commonData[i]['contract_period_to'],
          contract_prev_bal: commonData[i]['contract_prev_bal'],
          cust_name: commonData[i]['cust_name'],
          gst_include_exclude: commonData[i]['gst_include_exclude'],
          igst: commonData[i]['igst'],
          instruction: commonData[i]['instruction'],
          issue_date: commonData[i]['issue_date'],
          issue_name: commonData[i]['issue_name'],
          off_rep_name: commonData[i]['off_rep_name'],
          page_no: commonData[i]['page_no'],
          pages_no: commonData[i]['pages_no'],
          rep_mob_no: commonData[i]['rep_mob_no'],
          rep_name: commonData[i]['rep_name'],
          sgst: commonData[i]['sgst'],
          size: commonData[i]['size'],
          sub_gst_include_exclude: commonData[i]['sub_gst_include_exclude'],
          sub_id: commonData[i]['sub_id'],
          total_amount: commonData[i]['total_amount'],
          april1stWeekSize:
            this.formattedDate(
              this.firstSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          april1stWeekAmt:
            this.formattedDate(
              this.firstSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          april1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          april2ndWeekSize:
            this.formattedDate(
              this.secondSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          april2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          april2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          april3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          april3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          april3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          april4thWeekSize:
            this.formattedDate(
              this.fourthSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          april4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          april4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          april5thWeekSize:
            this.formattedDate(
              this.fifthSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          april5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          april5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(3, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          may1stWeekSize:
            this.formattedDate(
              this.firstSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          may1stWeekAmt:
            this.formattedDate(
              this.firstSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          may1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          may2ndWeekSize:
            this.formattedDate(
              this.secondSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          may2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          may2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          may3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          may3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          may3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          may4thWeekSize:
            this.formattedDate(
              this.fourthSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          may4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          may4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          may5thWeekSize:
            this.formattedDate(
              this.fifthSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          may5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          may5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(4, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          june1stWeekSize:
            this.formattedDate(
              this.firstSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          june1stWeekAmt:
            this.formattedDate(
              this.firstSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          june1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          june2ndWeekSize:
            this.formattedDate(
              this.secondSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          june2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          june2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          june3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          june3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          june3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          june4thWeekSize:
            this.formattedDate(
              this.fourthSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          june4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          june4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          june5thWeekSize:
            this.formattedDate(
              this.fifthSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          june5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          june5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(5, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          july1stWeekSize:
            this.formattedDate(
              this.firstSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          july1stWeekAmt:
            this.formattedDate(
              this.firstSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          july1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          july2ndWeekSize:
            this.formattedDate(
              this.secondSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          july2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          july2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          july3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          july3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          july3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          july4thWeekSize:
            this.formattedDate(
              this.fourthSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          july4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          july4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          july5thWeekSize:
            this.formattedDate(
              this.fifthSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          july5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          july5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(6, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          august1stWeekSize:
            this.formattedDate(
              this.firstSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          august1stWeekAmt:
            this.formattedDate(
              this.firstSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          august1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          august2ndWeekSize:
            this.formattedDate(
              this.secondSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          august2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          august2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          august3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          august3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          august3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          august4thWeekSize:
            this.formattedDate(
              this.fourthSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          august4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          august4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          august5thWeekSize:
            this.formattedDate(
              this.fifthSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          august5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          august5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(7, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          september1stWeekSize:
            this.formattedDate(
              this.firstSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          september1stWeekAmt:
            this.formattedDate(
              this.firstSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          september1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          september2ndWeekSize:
            this.formattedDate(
              this.secondSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          september2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          september2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          september3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          september3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          september3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          september4thWeekSize:
            this.formattedDate(
              this.fourthSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          september4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          september4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          september5thWeekSize:
            this.formattedDate(
              this.fifthSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          september5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          september5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(8, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          october1stWeekSize:
            this.formattedDate(
              this.firstSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          october1stWeekAmt:
            this.formattedDate(
              this.firstSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          october1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          october2ndWeekSize:
            this.formattedDate(
              this.secondSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          october2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          october2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          october3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          october3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          october3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          october4thWeekSize:
            this.formattedDate(
              this.fourthSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          october4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          october4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          october5thWeekSize:
            this.formattedDate(
              this.fifthSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          october5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          october5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(9, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          november1stWeekSize:
            this.formattedDate(
              this.firstSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          november1stWeekAmt:
            this.formattedDate(
              this.firstSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          november1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          november2ndWeekSize:
            this.formattedDate(
              this.secondSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          november2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          november2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          november3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          november3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          november3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          november4thWeekSize:
            this.formattedDate(
              this.fourthSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          november4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          november4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          november5thWeekSize:
            this.formattedDate(
              this.fifthSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          november5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          november5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(10, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          december1stWeekSize:
            this.formattedDate(
              this.firstSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          december1stWeekAmt:
            this.formattedDate(
              this.firstSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          december1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          december2ndWeekSize:
            this.formattedDate(
              this.secondSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          december2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          december2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          december3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          december3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          december3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          december4thWeekSize:
            this.formattedDate(
              this.fourthSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          december4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          december4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          december5thWeekSize:
            this.formattedDate(
              this.fifthSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          december5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          december5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(11, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          january1stWeekSize:
            this.formattedDate(
              this.firstSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          january1stWeekAmt:
            this.formattedDate(
              this.firstSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          january1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          january2ndWeekSize:
            this.formattedDate(
              this.secondSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          january2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          january2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          january3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          january3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          january3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          january4thWeekSize:
            this.formattedDate(
              this.fourthSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          january4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          january4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          january5thWeekSize:
            this.formattedDate(
              this.fifthSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          january5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          january5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(0, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          feb1stWeekSize:
            this.formattedDate(
              this.firstSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          feb1stWeekAmt:
            this.formattedDate(
              this.firstSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          feb1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          feb2ndWeekSize:
            this.formattedDate(
              this.secondSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          feb2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          feb2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          feb3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          feb3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          feb3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          feb4thWeekSize:
            this.formattedDate(
              this.fourthSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          feb4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          feb4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          feb5thWeekSize:
            this.formattedDate(
              this.fifthSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          feb5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          feb5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(1, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          march1stWeekSize:
            this.formattedDate(
              this.firstSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          march1stWeekAmt:
            this.formattedDate(
              this.firstSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          march1stWeekPageNo:
            this.formattedDate(
              this.firstSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          march2ndWeekSize:
            this.formattedDate(
              this.secondSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          march2ndWeekAmt:
            this.formattedDate(
              this.secondSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          march2ndWeekPageNo:
            this.formattedDate(
              this.secondSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          march3rdWeekSize:
            this.formattedDate(
              this.thirdSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          march3rdWeekAmt:
            this.formattedDate(
              this.thirdSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          march3rdWeekPageNo:
            this.formattedDate(
              this.thirdSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          march4thWeekSize:
            this.formattedDate(
              this.fourthSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          march4thWeekAmt:
            this.formattedDate(
              this.fourthSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          march4thWeekPageNo:
            this.formattedDate(
              this.fourthSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
          march5thWeekSize:
            this.formattedDate(
              this.fifthSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['size']
              : '',
          march5thWeekAmt:
            this.formattedDate(
              this.fifthSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['total_amount']
              : '',
          march5thWeekPageNo:
            this.formattedDate(
              this.fifthSunday(2, this.formatYear(this.today))
            ) == commonData[i]['issue_date'].split(',')[0]
              ? commonData[i]['pages_no']
              : '',
        });
      }

      this.indetailsData.push({
        name: data[index]['off_rep_name'],
        data: sortedDataCommon,
        contract_prev_bal,
        remaining_contract,
        contract_amt,
        contract_discnt_amt,
        contract_net_amt,
        contract_net_gst_amt,
        contract_net_total,
      });



      // setTimeout(() => {
      //   this.count = 5;
      this.cdr.detectChanges();
      // }, 1000);
    }

    console.log(this.indetailsData, "indetailsData");
  }

  formatYear(date) {
    return formatDate(date, 'yyyy', 'en-IN', 'GMT+0530');
  }

  formattedDate(date) {
    return formatDate(date, 'dd/MM/yyyy', 'en-IN', 'GMT+0530');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  calculateTotalAmount(...args) {
    return args.reduce((acc, curr) => {
      // console.log(curr == '' ? 0 : parseFloat(curr));
      let a = curr == '' ? 0 : parseFloat(curr);
      return acc + a;
    }, 0);
  }

  formatWholeNumber(amount: string | number): string {
    if (!amount) return '';

    const cleanedAmount = parseFloat(String(amount).replace(/,/g, ''));

    const roundedAmount = Math.round(cleanedAmount);

    return roundedAmount === 0 ? '' : String(roundedAmount);
  }


  print() {
    const originalTitle = document.title;
    document.title = '';

    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        table.report-table {
          table-layout: auto !important;
        }
  
        .report-table tr {
          break-inside: avoid !important;
          page-break-inside: avoid !important;
        }
  
        .invoice-no {
          white-space: normal;
          word-break: break-word;
          font-weight: bold;
          border-right: 1px solid #000;
          width: auto !important;
          min-width: 150px !important;
          max-width: 200px !important;
        }
  
        .advt-name {
          border: 1px solid black;
          font-size: 11px;
          font-weight: bold;
          padding: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 240px;
        }
  
        .advt-amt-col {
          width: 60px !important;
          max-width: 60px !important;
        }
  
        @page {
          size: A4;
          margin: 20mm;
        }
  
        .noPrint {
          display: none !important;
        }
  
        #print-section,
        #print-section * {
          visibility: visible;
        }
  
        #print-section {
          position: relative;
        }
  
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
  
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
      }
    `;

    document.head.appendChild(style);

    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) {
        (printTrigger as HTMLElement).click();
      }
      document.title = originalTitle;
    }, 500);
  }

  //  getBrieflyContractDetails() {
  //   // Parse startDate (e.g. "01-04-2026") to get fiscal year start
  //   let fiscalYear: number;
  //   if (this.startDate) {
  //     const parts = this.startDate.split('-'); // ["01","04","2026"]
  //     fiscalYear = parseInt(parts[2]); // 2026
  //   } else {
  //     const today = new Date();
  //     fiscalYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  //   }

  //   // Build label like "२०२६-२७"
  //   this.fiscalYearLabel = this.toDevanagari(fiscalYear) + '-' + this.toDevanagari((fiscalYear + 1) % 100);

  //   const req: any = {
  //     "rep_name": this.repName,
  //     "start_date": this.startDate,
  //     "end_date": this.endDate,
  //     "off_rep_name": this.offRepName,
  //     "advt_name": this.advtName,
  //     "issue_name": "",
  //     "fiscal_year": fiscalYear  // now correctly 2026
  //   };

  //   // same endpoint indetail uses → gives bookings[] + correct aaj_akher_vaprle
  //   this.service.getAllIndetailsContractDetails(req).subscribe((response: any) => {
  //     const rawContracts: any[] = response?.contracts || [];

  //     // The indetail endpoint's contract objects have no advt_name/rep_name/off_rep_name
  //     // at the top level — those only exist inside bookings[]. Without pulling them up,
  //     // every contract-with-bookings shared the same blank grouping key ("||") and got
  //     // merged into a single garbled row.
  //     const contractsWithBookings: any[] = rawContracts.map((c: any) => {
  //       const firstBooking = (c.bookings && c.bookings.length) ? c.bookings[0] : null;
  //       return {
  //         ...c,
  //         advt_name:    c.advt_name    || firstBooking?.advt_name    || c.cust_name || '',
  //         rep_name:     c.rep_name     || firstBooking?.rep_name     || '',
  //         off_rep_name: c.off_rep_name || firstBooking?.off_rep_name || '',
  //       };
  //     });

  //     const existingContractNos = new Set(contractsWithBookings.map((c: any) => c.contract_no));
  //     this.service.getAllContractDetails(year).subscribe((res: any) => {
  //       const allContracts: any[] = res?.data || res || [];

  //       const yearStart = new Date(year, 3, 1);
  //       const yearEnd   = new Date(year + 1, 2, 31);

  //       // contracts that exist this year but have no booking/invoice yet
  //       const noBookingContracts = allContracts.filter((c: any) => {
  //         if (existingContractNos.has(c.contract_no)) return false;

  //         const fromDate = c.contract_period_from ? new Date(c.contract_period_from) : null;
  //         const toDate   = c.contract_period_to   ? new Date(c.contract_period_to)   : null;

  //         const inYear =
  //           (fromDate && fromDate >= yearStart && fromDate <= yearEnd) ||
  //           (toDate   && toDate   >= yearStart && toDate   <= yearEnd) ||
  //           (fromDate && toDate   && fromDate  <= yearStart && toDate >= yearEnd);

  //         if (!inYear) return false;

  //         if (this.repName    && this.repName    !== '' && !this.repName.includes(c.rep_name))       return false;
  //         if (this.offRepName && this.offRepName !== '' && !this.offRepName.includes(c.off_rep_name)) return false;
  //         if (this.advtName   && this.advtName   !== '' && this.advtName !== c.advt_name)             return false;

  //         return true;
  //       });

  //       for (const c of noBookingContracts) {
  //         contractsWithBookings.push({
  //           ...c,
  //           aaj_akher_vaprle: parseFloat(c.till_date_used) || 0,
  //           bookings: []
  //         });
  //       }

  //       this.buildBrieflyContractData(contractsWithBookings);
  //     });
  //   });
  // }


  // getBrieflyContractDetails() {
  //   let fiscalYear: number;
  //   if (this.startDate) {
  //     const parts = this.startDate.split('-');
  //     fiscalYear = parts[0].length === 4 ? parseInt(parts[0]) : parseInt(parts[2]);
  //   } else {
  //     const today = new Date();
  //     fiscalYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  //   }

  //   this.fiscalYearLabel = this.toDevanagari(fiscalYear) + '-' + this.toDevanagari((fiscalYear + 1) % 100);

  //   console.log('startDate:', this.startDate, '→ fiscalYear:', fiscalYear, 
  //               '→ advtName:', this.advtName, '→ label:', this.fiscalYearLabel);

  //   const req: any = {
  //     "rep_name": this.repName,
  //     "start_date": this.startDate,
  //     "end_date": this.endDate,
  //     "off_rep_name": this.offRepName,
  //     "advt_name": this.advtName,  // ✅ passed to first API
  //     "issue_name": "",
  //     "fiscal_year": fiscalYear
  //   };

  //   this.service.getAllIndetailsContractDetails(req).subscribe((response: any) => {
  //     const rawContracts: any[] = response?.contracts || [];

  //     const contractsWithBookings: any[] = rawContracts.map((c: any) => {
  //       const firstBooking = (c.bookings && c.bookings.length) ? c.bookings[0] : null;
  //       return {
  //         ...c,
  //         advt_name:    c.advt_name    || firstBooking?.advt_name    || c.cust_name || '',
  //         rep_name:     c.rep_name     || firstBooking?.rep_name     || '',
  //         off_rep_name: c.off_rep_name || firstBooking?.off_rep_name || '',
  //       };
  //     });

  //     const existingContractNos = new Set(contractsWithBookings.map((c: any) => c.contract_no));

  //     // ✅ Pass advtName to second API so PHP filters it
  //     this.service.getAllContractDetails1(fiscalYear, this.advtName).subscribe((res: any) => {
  //       const allContracts: any[] = res?.data || res || [];

  //       console.log('getAllContractDetails returned:', allContracts.length, 'contracts for advt:', this.advtName);

  //       const yearStart = new Date(fiscalYear, 3, 1);
  //       const yearEnd   = new Date(fiscalYear + 1, 2, 31);

  //       const noBookingContracts = allContracts.filter((c: any) => {
  //         if (existingContractNos.has(c.contract_no)) return false;

  //         const fromDate = c.contract_period_from ? new Date(c.contract_period_from) : null;
  //         const toDate   = c.contract_period_to   ? new Date(c.contract_period_to)   : null;

  //         const inYear =
  //           (fromDate && fromDate >= yearStart && fromDate <= yearEnd) ||
  //           (toDate   && toDate   >= yearStart && toDate   <= yearEnd) ||
  //           (fromDate && toDate   && fromDate  <= yearStart && toDate >= yearEnd);

  //         return inYear;  // advt_name already filtered by PHP
  //       });

  //       for (const c of noBookingContracts) {
  //         contractsWithBookings.push({
  //           ...c,
  //           aaj_akher_vaprle: parseFloat(c.till_date_used) || 0,
  //           bookings: []
  //         });
  //       }

  //       this.buildBrieflyContractData(contractsWithBookings);
  //     });
  //   });
  // }

  // getBrieflyContractDetails() {
  //   let fiscalYear: number;
  //   if (this.startDate) {
  //     const parts = this.startDate.split('-');
  //     fiscalYear = parts[0].length === 4 ? parseInt(parts[0]) : parseInt(parts[2]);
  //   } else {
  //     const today = new Date();
  //     fiscalYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
  //   }

  //   this.fiscalYearLabel = this.toDevanagari(fiscalYear) + '-' +
  //     this.toDevanagari((fiscalYear + 1) % 100);

  //   // ✅ Confirm value right before both API calls
  //   console.log('getBrieflyContractDetails → advtName:', JSON.stringify(this.advtName));

  //   const req: any = {
  //     rep_name: this.repName,
  //     start_date: this.startDate,
  //     end_date: this.endDate,
  //     off_rep_name: this.offRepName,
  //     advtName: Array.isArray(this.advtName)
  //       ? this.advtName.join(',').trim()
  //       : (this.advtName || '').trim(),
  //     issue_name: '',
  //     fiscal_year: fiscalYear
  //   };

  //   this.service.getAllIndetailsContractDetails(req).subscribe((response: any) => {
  //     const rawContracts: any[] = response?.contracts || [];

  //     const contractsWithBookings: any[] = rawContracts.map((c: any) => {
  //       const firstBooking = c.bookings?.length ? c.bookings[0] : null;
  //       return {
  //         ...c,
  //         advt_name: c.advt_name || firstBooking?.advt_name || c.cust_name || '',
  //         rep_name: c.rep_name || firstBooking?.rep_name || '',
  //         off_rep_name: c.off_rep_name || firstBooking?.off_rep_name || '',
  //       };
  //     });

  //     const existingContractNos = new Set(contractsWithBookings.map((c: any) => c.contract_no));

  //     const advtNameToSend = Array.isArray(this.advtName)
  //       ? this.advtName.join(',').trim()
  //       : (this.advtName || '').trim();

  //     console.log(
  //       'Sending to getAllContractDetails1 → advtName:',
  //       JSON.stringify(advtNameToSend),
  //       '| length:',
  //       advtNameToSend.length
  //     );

  //     this.service.getAllContractDetails1(fiscalYear, advtNameToSend).subscribe((res: any) => {
  //       const allContracts: any[] = res?.data || res || [];
  //       console.log('getAllContractDetails1 returned:', allContracts.length, 'rows');

  //       const yearStart = new Date(fiscalYear, 3, 1);
  //       const yearEnd = new Date(fiscalYear + 1, 2, 31);

  //       const noBookingContracts = allContracts.filter((c: any) => {
  //         if (existingContractNos.has(c.contract_no)) return false;
  //         const fromDate = c.contract_period_from ? new Date(c.contract_period_from) : null;
  //         const toDate = c.contract_period_to ? new Date(c.contract_period_to) : null;
  //         return (fromDate && fromDate >= yearStart && fromDate <= yearEnd) ||
  //           (toDate && toDate >= yearStart && toDate <= yearEnd) ||
  //           (fromDate && toDate && fromDate <= yearStart && toDate >= yearEnd);
  //       });

  //       for (const c of noBookingContracts) {
  //         contractsWithBookings.push({
  //           ...c,
  //           aaj_akher_vaprle: parseFloat(c.till_date_used) || 0,
  //           bookings: []
  //         });
  //       }

  //       this.buildBrieflyContractData(contractsWithBookings);
  //     });
  //   });
  // }

//   getBrieflyContractDetails() {
//   const advtNameToSend = Array.isArray(this.advtName)
//     ? this.advtName.map((x: any) => x.item_text || x).join(',')
//     : (this.advtName || '').trim();

//   const yearToSend = this.year || 2026;

//   this.contractData = [];
//   this.filteredcontractData = [];
//   this.resetBriefTotals();

//   this.service.getAllContractDetails1(yearToSend, advtNameToSend).subscribe((res: any) => {
//     console.log('Brief API Response:', res);

//     this.contractData = res?.data || [];
//     this.filteredcontractData = res?.data || [];

//     console.log('UI contractData:', this.contractData);

//     this.calculateBriefTotals();
//     this.cdr.detectChanges();
//   });
// }

getBrieflyContractDetails() {
  const advtNameToSend = Array.isArray(this.advtName)
    ? this.advtName.map((x: any) => x.item_text || x).join(',')
    : (this.advtName || '').trim();

  // NEW: build comma-separated rep/off-rep strings the same way
  const repNameToSend = Array.isArray(this.repName)
    ? this.repName.map((x: any) => x.item_text || x).join(',')
    : (this.repName || '').trim();

  const offRepNameToSend = Array.isArray(this.offRepName)
    ? this.offRepName.map((x: any) => x.item_text || x).join(',')
    : (this.offRepName || '').trim();

  const yearToSend = this.year || 2026;

  this.contractData = [];
  this.filteredcontractData = [];
  this.resetBriefTotals();

  this.service
    .getAllContractDetails1(yearToSend, advtNameToSend, repNameToSend, offRepNameToSend)
    .subscribe((res: any) => {
      this.contractData = res?.data || [];
      this.filteredcontractData = res?.data || [];
      this.calculateBriefTotals();
      this.cdr.detectChanges();
    });
}

  buildBrieflyContractData(contracts: any[]) {

    // merge multi-period contracts of same advt+rep so prev_bal isn't double counted
    const advtGroups: { [key: string]: any[] } = {};
    for (const item of contracts) {
      const key = (item.advt_name || item.cust_name || '') + '|' +
        (item.rep_name || '') + '|' + (item.off_rep_name || '');
      if (!advtGroups[key]) advtGroups[key] = [];
      advtGroups[key].push(item);
    }

    const rows: any[] = [];

    this.lastcontract = 0;
    this.remaincontract = 0;
    this.newcontract = 0;
    this.agencydiscontract = 0;
    this.totalcontract = 0;
    this.gstcontract = 0;
    this.grandtotalcontract = 0;

    this.totalData = {
      contract_prev_bal: 0,
      remaining_contract: 0,
      contract_amt: 0,
      contract_discnt_amt: 0,
      contract_net_amt: 0,
      contract_net_gst_amt: 0,
      contract_net_total: 0,
      total_march_end: 0,
      next_year: 0,
      till_date_used: 0,
      use_till_march_end: 0,
    };

    for (const key in advtGroups) {
      const group = advtGroups[key];
      const merged = group.length === 1 ? { ...group[0] } : this.mergeContractsForSameAdvt(group);

      const total_march_end = this.calculateTotalMarchEndForContracts(group);
      const till_date_used = this.calculateUsedTillToday(merged);
      const next_year = this.calculateForNextYear(merged, total_march_end);
      const use_till_march_end = total_march_end - till_date_used;

      merged.total_march_end = total_march_end;
      merged.till_date_used = till_date_used;
      merged.next_year = next_year;
      merged.use_till_march_end = use_till_march_end;

      rows.push(merged);

      this.lastcontract += parseFloat(merged.contract_prev_bal) || 0;
      this.newcontract += parseFloat(merged.contract_amt) || 0;
      this.agencydiscontract += parseFloat(merged.contract_discnt_amt) || 0;
      this.totalcontract += parseFloat(merged.contract_net_amt) || 0;
      this.gstcontract += parseFloat(merged.contract_net_gst_amt) || 0;
      this.grandtotalcontract += parseFloat(merged.contract_net_total) || 0;

      this.totalData.contract_prev_bal += parseFloat(merged.contract_prev_bal) || 0;
      this.totalData.contract_amt += parseFloat(merged.contract_amt) || 0;
      this.totalData.contract_discnt_amt += parseFloat(merged.contract_discnt_amt) || 0;
      this.totalData.contract_net_amt += parseFloat(merged.contract_net_amt) || 0;
      this.totalData.contract_net_gst_amt += parseFloat(merged.contract_net_gst_amt) || 0;
      this.totalData.contract_net_total += parseFloat(merged.contract_net_total) || 0;
      this.totalData.remaining_contract += parseFloat(merged.contract_bal_amt) || 0;

      this.totalData.total_march_end += total_march_end;
      this.totalData.till_date_used += till_date_used;
      this.totalData.next_year += next_year;
      this.totalData.use_till_march_end += use_till_march_end;
    }

    this.contractData = rows;
    this.filteredcontractData = rows;

    console.log('briefly contractData (corrected)', this.contractData);
    console.log('totalData (corrected)', this.totalData);

    this.cdr.detectChanges();
  }

  // ---- same calc logic as ContractIndetailReportComponent ----

  calculateTotalMarchEndForContracts(contracts: any[]): number {
    let total = 0;
    for (const c of contracts) {
      if (c.bookings && c.bookings.length) {
        for (const b of c.bookings) {
          total += parseFloat(b.amount) || 0;
        }
      }
    }
    return total;
  }

  calculateUsedTillToday(item: any): number {
    return parseFloat(item['aaj_akher_vaprle']) || 0;
  }

  calculateForNextYear(item: any, totalMarchEnd: number): number {
    if (item.is_previous_contract === true) {
      const remaining = parseFloat(item['contract_prev_bal']) || 0;
      const usedTillToday = this.calculateUsedTillToday(item);
      return Math.max(0, remaining - usedTillToday);
    }

    const totalContractValue =
      (parseFloat(item['contract_prev_bal']) || 0) +
      (parseFloat(item['contract_net_total']) || 0);

    const remaining = totalContractValue - totalMarchEnd;
    return remaining > 0 ? remaining : 0;
  }

  mergeContractsForSameAdvt(contracts: any[]): any {
    const sorted = [...contracts].sort((a, b) => {
      const dateA = new Date(a.contract_period_from || 0).getTime();
      const dateB = new Date(b.contract_period_from || 0).getTime();
      return dateA - dateB;
    });

    const newContract = { ...sorted[sorted.length - 1] };

    let totalPrevBal = 0;
    for (let i = 0; i < sorted.length - 1; i++) {
      totalPrevBal += (parseFloat(sorted[i]['contract_prev_bal']) || 0)
        + (parseFloat(sorted[i]['contract_net_total']) || 0);
    }
    totalPrevBal += parseFloat(newContract['contract_prev_bal']) || 0;

    const totalPaid = sorted.reduce((sum, c) => sum + (parseFloat(c['aaj_akher_vaprle']) || 0), 0);

    return {
      ...newContract,
      contract_prev_bal: totalPrevBal,
      contract_period_from: sorted[0].contract_period_from,
      contract_period_to: sorted[sorted.length - 1].contract_period_to,
      aaj_akher_vaprle: totalPaid,
    };
  }


  fiscalYearLabel: string = '';

  toDevanagari(num: number): string {
    const devanagariDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return String(num).split('').map(d => devanagariDigits[parseInt(d)]).join('');
  }

  resetBriefTotals() {
  this.lastcontract = 0;
  this.remaincontract = 0;
  this.newcontract = 0;
  this.agencydiscontract = 0;
  this.totalcontract = 0;
  this.gstcontract = 0;
  this.grandtotalcontract = 0;

  this.totalData = {
    contract_prev_bal: 0,
    remaining_contract: 0,
    contract_amt: 0,
    contract_discnt_amt: 0,
    contract_net_amt: 0,
    contract_net_gst_amt: 0,
    contract_net_total: 0,
    total_march_end: 0,
    next_year: 0,
    till_date_used: 0,
    use_till_march_end: 0,
  };
}

calculateBriefTotals() {
  for (let row of this.contractData) {
    this.lastcontract += +row.contract_prev_bal || 0;
    this.remaincontract += +row.contract_bal_amt || 0;
    this.newcontract += +row.contract_amt || 0;
    this.agencydiscontract += +row.contract_discnt_amt || 0;
    this.totalcontract += +row.contract_net_amt || 0;
    this.gstcontract += +row.contract_net_gst_amt || 0;
    this.grandtotalcontract += +row.contract_net_total || 0;

    this.totalData.remaining_contract += +row.contract_bal_amt || 0;
    this.totalData.total_march_end += +row.total_march_end || 0;
    this.totalData.next_year += +row.next_year || 0;
    this.totalData.till_date_used += +row.till_date_used || 0;
    this.totalData.use_till_march_end += +row.use_till_march_end || 0;
  }
}

}
